var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "message-container d-flex justify-content-end mb-2 outbound",
    },
    [
      _vm.isSpecialMessage
        ? _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _vm.isEmailGroupMessage
                ? _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "light",
                        placement: "left",
                        content: "Email group message",
                      },
                    },
                    [_c("i", { staticClass: "fas fa-users mr-1" })]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "message" }, [
        _c("div", { staticClass: "header text-right font-weight-bold" }, [
          _vm.getEmailAddressTitle
            ? _c("span", { staticClass: "outgoing-number-title" }, [
                _vm._v(_vm._s(_vm._f("uppercase")(_vm.getEmailAddressTitle))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "outgoing-number-phone-number" }, [
            _vm._v(_vm._s(_vm._f("uppercase")(_vm.getEmailAddress))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content d-flex flex-column", style: _vm.styles },
          [
            _c(
              "div",
              { staticClass: "content-body w-100 d-flex flex-column" },
              [
                _c(
                  "div",
                  {
                    staticClass: "message-subject w-100 cursor-pointer",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onShowBody.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("b", [_vm._v("Subject:")]),
                    _vm._v(" " + _vm._s(_vm.getSubject) + "\n          "),
                    _c("i", {
                      staticClass: "fas ml-2 mr-1",
                      class: [
                        _vm.showBody ? "fa-chevron-up" : "fa-chevron-down",
                      ],
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("event-list", { attrs: { items: _vm.getEvents } }),
                _vm._v(" "),
                _vm.showBody
                  ? _c(
                      "div",
                      { staticClass: "w-100 mt-2" },
                      [
                        _c("iframe-loader", {
                          attrs: { url: _vm.getPreviewUrl },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer text-right", class: _vm.statusClasses },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm._f("uppercase")(_vm.statusString)) +
                "\n    "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "logo ml-1" },
        [
          _c("el-image", {
            staticClass: "avatar",
            attrs: { src: _vm.logo, fit: "contain" },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass: "mr-2",
        staticStyle: { "font-size": "24px", "vertical-align": "middle" },
      },
      [_c("i", { staticClass: "fas fa-envelope" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }